//
export default [
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'tipo',
        value: ({ hr_asset_discount_type }) => hr_asset_discount_type.type,
    },
]